import * as Sentry from '@sentry/vue'

/**
 * Kintone 疎通 NG により障害ページへリダイレクトしたことを Sentry へ 1 件通知する。
 *
 * - 送るのは `ng` 判定でリダイレクトしたときだけ（呼び出し側で判定済み）
 * - グローバルスコープを汚す Sentry API は使わない（ユーザー情報・コンテキスト・タグ・
 *   パンくずの設定は行わない）。`captureContext`（第2引数）でこのイベントだけにタグ・
 *   付帯情報を付ける
 * - 個人情報・秘匿情報は送らない。`extra` は `from`（route.path）のみ
 * - 決して throw しない。失敗は console.warn 1 行に留める
 */
export function reportKintoneOutageRedirect(from: string): void {
  try {
    Sentry.captureMessage(
      'kintoneHealth: connectivity ng, redirected to outage page',
      {
        level: 'warning',
        tags: { feature: 'kintone-health' },
        extra: { from },
      }
    )
  } catch (e: any) {
    console.warn('[kintoneHealth] Sentry report failed', e?.message)
  }
}
